export const collectionIndicator = ["#1A30FF", "#B30000", "#036168", "#8800D1", "#505C00", "#A8006B"];

const colors = {};

/** Get collection color from collection indicator from design
 * @method
 * @param { string } name collection name
 * @returns { string } color for collection title
 */
const getCollectionColor = (name) => {
  if (colors[name]) {
    return colors[name];
  } else if (collectionIndicator.length) {
    const color = collectionIndicator.shift();
    colors[name] = color;
    collectionIndicator.push(colors[name]);
    return color;
  }
};

export default getCollectionColor;
